import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useWS } from '../../contexts/WSContext';
import api from '../../services/api';
import toast from 'react-hot-toast';

export default function CustomerWaiting() {
  const { orderId } = useParams();
  const nav = useNavigate();
  const { on, connect } = useWS();
  const [order, setOrder] = useState(null);
  const [dots, setDots] = useState('');

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) connect(token);
  }, []);

  useEffect(() => {
    api.get(`/orders/${orderId}`).then(r => {
      setOrder(r.data);
      if (r.data.status === 'accepted' || r.data.status === 'in_transit') {
        nav(`/cliente/rastreio/${orderId}`);
      }
      if (r.data.status === 'delivered') {
        nav('/cliente/historico');
      }
    });
  }, [orderId]);

  useEffect(() => {
    const off = on('order_accepted', (msg) => {
      if (msg.order?.id === orderId || msg.order?.customerId) {
        toast.success('Entregador a caminho!');
        nav(`/cliente/rastreio/${orderId}`);
      }
    });
    return off;
  }, [on, orderId]);

  useEffect(() => {
    const t = setInterval(() => setDots(d => d.length >= 3 ? '' : d + '.'), 500);
    return () => clearInterval(t);
  }, []);

  // Poll order status every 5s
  useEffect(() => {
    const t = setInterval(() => {
      api.get(`/orders/${orderId}`).then(r => {
        if (['accepted', 'in_transit'].includes(r.data.status)) {
          nav(`/cliente/rastreio/${orderId}`);
        }
      });
    }, 5000);
    return () => clearInterval(t);
  }, [orderId]);

  return (
    <div className="screen bg-[#1A1A2E] flex flex-col items-center justify-center text-white px-6 text-center">
      {/* Animated flame */}
      <div className="relative mb-8">
        <img src="/logo.png" alt="GasNaPorta" className="w-40 h-40 object-contain animate-bounce drop-shadow-2xl" />
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="w-44 h-44 rounded-full border-4 border-primary/30 animate-ping" />
        </div>
      </div>

      <h1 className="text-2xl font-black mb-2">Buscando Entregador{dots}</h1>
      <p className="text-gray-400 text-sm max-w-xs">
        Notificamos os entregadores disponíveis na sua região. O primeiro a aceitar irá te atender!
      </p>

      {order && (
        <div className="mt-8 bg-white/10 rounded-2xl p-4 w-full max-w-xs text-left space-y-2">
          <div className="flex items-center gap-2">
            <span className="text-xl">{order.brandEmoji}</span>
            <span className="font-bold">{order.brandName} — {order.sizeLabel}</span>
          </div>
          <div className="text-sm text-gray-400">📍 {order.address}</div>
          <div className="text-sm text-gray-400">💰 R$ {order.customerPrice?.toFixed(2)}</div>
          <div className="flex items-center gap-2 mt-3">
            <div className="w-2 h-2 rounded-full bg-green-400 animate-pulse" />
            <span className="text-xs text-green-400">Pagamento confirmado</span>
          </div>
        </div>
      )}

      <p className="mt-8 text-xs text-gray-600">
        Aguarde... Isso pode levar alguns instantes
      </p>
    </div>
  );
}
